import Api from '@common/services/api';

export const leaveConversation = async (orgId: string, conversationId: string) => {
  return Api.post(`/v3/organisations/${orgId}/conversations/${conversationId}/leave`);
};
